'use client';
import ErrorMessage from '@/ui/ErrorMessage';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { vs2015 } from 'react-syntax-highlighter/dist/esm/styles/hljs';

const SqlError: React.FC<{ sql: string | undefined }> = ({ sql }) => (
  <ErrorMessage
    title="Error parsing SQL"
    code={
      <SyntaxHighlighter language="pgsql" style={vs2015} wrapLongLines>
        {sql || ''}
      </SyntaxHighlighter>
    }
  >
    <div>The below query does not appear to be valid SQL. Remove the query and try again.</div>
  </ErrorMessage>
);

export default SqlError;
